// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("assets/" + (chunkId === 415 ? "mediabunny" : chunkId) + "." + {"288":"f831723064f9","415":"546610851325"}[chunkId] + ".js");